/**
 * Browser-console JavaScript (as source lines) that fills Suno's Create-page lyrics box.
 *
 * Suno's lyrics box (Manual mode, the default) is a Lexical rich-text editor:
 *   <div contenteditable="true" class="lyrics-editor-content" data-lexical-editor="true" role="textbox">
 * It is NOT a <textarea>, and its "placeholder" is a separate <div>, so value-setter injection
 * does nothing. The only <textarea> that mentions lyrics is the Auto-mode "describe the lyrics"
 * prompt, which is a description for Suno's own writer, not lyrics.
 *
 * The editor mounts lazily (Suspense) and shows data-lyrics-draft-loading="true" while the saved
 * draft loads, so the script waits for both, switches the Lyrics toggle to Manual if the editor
 * is hidden, pastes via a synthetic paste event (Lexical's own plain-text path), falls back to
 * execCommand, and then reads the editor back to confirm the text actually landed.
 */
export const SUNO_LYRICS_INJECTION_LINES: string[] = [
  '// Suno\'s lyrics box is a Lexical contenteditable (class "lyrics-editor-content"), not a <textarea>.',
  'async function injectLyrics(text) {',
  '    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));',
  '    const norm = (s) => (s || "").replace(/\\s+/g, " ").trim();',
  '    const findEditor = () => document.querySelector(\'.lyrics-editor-content[contenteditable="true"], [data-lexical-editor="true"][contenteditable="true"], div[aria-label="Lyrics editor"][contenteditable="true"]\');',
  '    let el = findEditor();',
  '    if (!el) {',
  '        // Auto / Instrumental mode hides the editor -- the first option of the lyrics toggle is Manual.',
  '        const manual = document.querySelector(\'[role="radiogroup"] button[role="radio"]\');',
  '        if (manual && manual.getAttribute("aria-checked") !== "true") { manual.click(); console.log("… switching lyrics mode to Manual"); }',
  '    }',
  '    for (let i = 0; i < 50 && !el; i++) { await sleep(150); el = findEditor(); }',
  '    if (!el) { console.warn("⚠ Lyrics editor not found. Set the Lyrics toggle to Manual and run again."); return false; }',
  '    for (let i = 0; i < 50 && document.querySelector(\'[data-lyrics-draft-loading="true"]\'); i++) await sleep(150);',
  '    const want = norm(text);',
  '    const landed = () => { const got = norm(el.textContent); return got.length > 0 && Math.abs(got.length - want.length) <= Math.max(10, want.length * 0.02); };',
  '    // 1) Select everything in the editor, then paste as plain text (the path Lexical is built to handle).',
  '    el.focus();',
  '    document.execCommand("selectAll", false, null);',
  '    await sleep(150); // let Lexical register the selection before the paste arrives',
  '    const dt = new DataTransfer();',
  '    dt.setData("text/plain", text);',
  '    el.dispatchEvent(new ClipboardEvent("paste", { clipboardData: dt, bubbles: true, cancelable: true }));',
  '    await sleep(350);',
  '    // 2) Fallback: native text insertion, one paragraph per line.',
  '    if (!landed()) {',
  '        el.focus();',
  '        document.execCommand("selectAll", false, null);',
  '        await sleep(150);',
  '        document.execCommand("delete", false, null);',
  '        const lines = text.split("\\n");',
  '        for (let i = 0; i < lines.length; i++) {',
  '            if (lines[i]) document.execCommand("insertText", false, lines[i]);',
  '            if (i < lines.length - 1) document.execCommand("insertParagraph", false, null);',
  '        }',
  '        await sleep(350);',
  '    }',
  '    if (landed()) { console.log("✓ Lyrics injected (" + norm(el.textContent).length + " chars)"); return true; }',
  '    console.warn("⚠ Lyrics were sent to the editor but did not stick (editor holds " + norm(el.textContent).length + " of " + want.length + " chars). Click into the lyrics box and run again.");',
  '    return false;',
  '}',
];
